import { render, staticRenderFns } from "./payCom.vue?vue&type=template&id=9713229c&scoped=true"
import script from "./payCom.vue?vue&type=script&lang=ts"
export * from "./payCom.vue?vue&type=script&lang=ts"
import style0 from "./payCom.vue?vue&type=style&index=0&id=9713229c&prod&lang=less&scoped=true"
import style1 from "./payCom.vue?vue&type=style&index=1&id=9713229c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9713229c",
  null
  
)

export default component.exports